import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function ResizeIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns='http://www.w3.org/2000/svg'
                 viewBox='0 0 24 24'
                 fill='none'
                 stroke='currentColor'
                 strokeWidth='2'
                 strokeLinecap='round'
                 strokeLinejoin='round'>
                <path d='M4 10V4h6' />
                <path d='M4 4l9 9' />
                <path d='M20 14v6h-6' />
                <path d='M20 20l-9-9' />
            </svg>

        </SvgIcon>
    );
}
